import { render, staticRenderFns } from "./OnlyBar.vue?vue&type=template&id=7313b72f&"
import script from "./OnlyBar.vue?vue&type=script&lang=js&"
export * from "./OnlyBar.vue?vue&type=script&lang=js&"
import style0 from "./OnlyBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports